import lazySizes from "lazysizes";

lazySizes.cfg.lazyClass = "is-lazy";
lazySizes.cfg.loadingClass = "is-loading";
lazySizes.cfg.loadedClass = "is-loaded";
